import { todayParis } from "../utils/calendar.mjs";
export function workMinutes(hours) {
  if (hours.off) return 0;
  const minutes = (value) => {
    if (!/^\d{2}:\d{2}$/.test(value || ""))
      throw new Error("Renseigne les horaires de début et de fin.");
    const [h, m] = value.split(":").map(Number);
    if (h > 23 || m > 59) throw new Error("Horaire invalide.");
    return h * 60 + m;
  };
  const start = minutes(hours.start),
    end = minutes(hours.end);
  if (end <= start) throw new Error("La fin doit être après le début.");
  if (!!hours.lunchStart !== !!hours.lunchEnd)
    throw new Error("Renseigne les deux horaires de pause.");
  let pause = 0;
  if (hours.lunchStart) {
    const a = minutes(hours.lunchStart),
      b = minutes(hours.lunchEnd);
    if (a < start || b > end || b <= a)
      throw new Error("La pause doit être comprise dans la journée.");
    pause = b - a;
  }
  return end - start - pause;
}
export function getWorkHours(state, userId, date) {
  const actual = (state.workHours || []).find(
    (x) => x.userId === userId && x.date === date,
  );
  if (actual) return { ...actual, source: "confirmed" };
  const template = (state.workSchedules || [])
    .filter((x) => x.userId === userId && x.from <= date)
    .sort((a, b) => a.from.localeCompare(b.from))
    .at(-1);
  const day = new Date(date + "T12:00:00Z").getUTCDay();
  if (template?.weekdays) return { ...template.weekdays[day], source: "usual", automatic: true };
  if (template)
    return {
      ...template.hours,
      off: !template.days.includes(day),
      days: template.days,
      source: "usual",
    };
  return {
    start: "",
    end: "",
    lunchStart: "",
    lunchEnd: "",
    off: false,
    source: "empty",
  };
}
export function saveWorkHours(
  state,
  userId,
  date,
  hours,
  schedule = null,
  now = new Date(),
) {
  workMinutes(hours);
  if (schedule) workMinutes({ ...hours, off: false });
  if (
    schedule &&
    (!schedule.days.length ||
      schedule.days.some((x) => !Number.isInteger(x) || x < 0 || x > 6))
  )
    throw new Error("Sélectionne les jours habituels de travail.");
  return {
    ...state,
    workHours: [
      ...(state.workHours || []).filter(
        (x) => x.userId !== userId || x.date !== date,
      ),
      { userId, date, ...hours, updatedAt: now.toISOString() },
    ],
    workSchedules: schedule
      ? [
          ...(state.workSchedules || []).filter(
            (x) => x.userId !== userId || x.from !== date,
          ),
          {
            userId,
            from: date,
            hours: { ...hours, off: false },
            days: schedule.days,
          },
        ]
      : state.workSchedules || [],
  };
}

export function workHoursReport(state, userId, from, to, now = new Date()) {
  const cutoff = todayParis(now);
  const records = dailyWorkRows(state, [[userId, ""]], from, to)
    .filter(row => row.hours.source === "confirmed" || (row.hours.automatic && row.date <= cutoff && !row.hours.off))
    .map(row => ({ ...row.hours, date: row.date }));
  const days = records.map(entry => {
    const planned = getWorkHours({ ...state, workHours: [] }, userId, entry.date);
    const actual = workMinutes(entry);
    const expected = planned.source === 'empty' ? null : workMinutes(planned);
    return { date: entry.date, source: entry.source, declaredAt: entry.updatedAt || null, start: entry.start, end: entry.end, lunchStart: entry.lunchStart, lunchEnd: entry.lunchEnd, actual, expected, extra: expected === null ? null : Math.max(0, actual - expected) };
  }).sort((a,b) => a.date.localeCompare(b.date));
  return {
    days,
    actual: days.reduce((sum,d) => sum + d.actual, 0),
    expected: days.reduce((sum,d) => sum + (d.expected || 0), 0),
    extra: days.reduce((sum,d) => sum + (d.extra || 0), 0),
    unclassified: days.filter(d => d.expected === null).length,
  };
}
export function formatWorkDuration(minutes) {
  return `${Math.floor(minutes / 60)} h ${String(minutes % 60).padStart(2, '0')}`;
}

export function dailyWorkRows(state, owners, from, to) {
  const rows = [];
  for (let date = from; date && date <= to;) {
    for (const [userId, name] of owners) rows.push({ userId, name, date, hours: getWorkHours(state, userId, date) });
    const next = new Date(date + 'T12:00:00Z');
    next.setUTCDate(next.getUTCDate() + 1);
    date = next.toISOString().slice(0,10);
  }
  return rows;
}

export function saveUsualWeek(state, userId, from, weekdays, actor, now = new Date()) {
  if (!['hyperadmin','manager','n+1'].includes(actor?.role)) throw new Error('Seul le N+1 peut enregistrer les horaires habituels.');
  if (!/^\d{4}-\d{2}-\d{2}$/.test(from)) throw new Error('Date obligatoire.');
  for(let day=0;day<7;day++) { if (!weekdays[day]) throw new Error('Renseigne chaque jour.'); workMinutes(weekdays[day]); }
  return { ...state, workSchedules: [...(state.workSchedules || []).filter(s=>s.userId!==userId || s.from!==from), { userId, from, weekdays, createdBy: actor.id, createdAt: now.toISOString() }] };
}
